import React, { useEffect, useState } from 'react';
import { PaymentRequestButtonElement } from 'react-stripe-elements';

import { Separator } from '../../components';

const PaymentButton = ({ amount, currency, country, processPayment, stripe }) => {
    const [paymentRequest, setPaymentRequest] = useState(null)

    useEffect(() => {
        const paymentRequest = stripe.paymentRequest({
            country: country,
            currency: currency,
            total: {
                label: 'Order total',
                amount: amount,
            },
            requestPayerName: true,
            requestPayerEmail: true,
        });

        paymentRequest.on('paymentmethod', async (event) => {
            // payment method data to pass to stripe
            const stripePaymentMethod = event.paymentMethod.id

            // payment method data to pass to the server
            const extraData = {
                stripe_method: event.paymentMethod.type
            }

            processPayment('stripe_button', stripePaymentMethod, extraData, event)
        });

        paymentRequest.canMakePayment().then(result => {
            if (result) {
                setPaymentRequest(paymentRequest);
            }
        });
    }, [stripe]);

    const style = {
        paymentRequestButton: {
            type: 'buy',
            theme: 'dark',
            height: "49px"
        }
    }

    return (
        <>
            {paymentRequest && (
                <div className="payment-button">
                    <PaymentRequestButtonElement paymentRequest={paymentRequest} style={style} />

                    <div className="pb-2 pt-2">
                        <Separator className="mt-5 mb-5" text="or enter your payment details below" />
                    </div>
                </div>
            )}
        </>
    )
};

export default PaymentButton;
